import { logout } from 'frontend-container/components/Menu/components/User/logout';
import { getBusinessContextData } from 'frontend-container/shared/businessContext/getBusinessContext';

import {
  GenericOverrideEntity,
  UserDetails,
  UserPreferences,
} from '@ac/library-api';

export interface FullCurrentUser {
  userDetails: UserDetails;
  department?: GenericOverrideEntity;
  jobTitle?: GenericOverrideEntity;
  userPreferences?: UserPreferences;
}

const getFullCurrentUser = (): FullCurrentUser => {
  const { user } = getBusinessContextData();

  return {
    userDetails: user.details,
    department: user.department,
    jobTitle: user.jobTitle,
    userPreferences: user.preferences,
  };
};

const getCurrentUserDetails = (): UserDetails => {
  const { user } = getBusinessContextData();

  return user.details;
};

const getCurrentUserPreferences = (): UserPreferences | undefined => {
  const { user } = getBusinessContextData();

  return user.preferences;
};

export const userService = {
  logout,
  getCurrentUserDetails,
  getCurrentUserPreferences,
  getFullCurrentUser,
};
